import React from "react";
import { Button, Form, ButtonGroup } from "react-bootstrap";
import { format, addDays, subDays } from "date-fns";

const CalendarControls = ({
  filter,
  setFilter,
  counts,
  currentDate,
  setCurrentDate,
}) => {
  const handlePrevDay = () => setCurrentDate(subDays(currentDate, 1));
  const handleNextDay = () => setCurrentDate(addDays(currentDate, 1));
  const handleDateChange = (e) => {
    if (e.target.value) {
      setCurrentDate(new Date(e.target.value));
    }
  };

  return (
    <div className="d-flex flex-wrap align-items-center p-3 bg-white border-bottom gap-3">
      {/* Date Controls */}
      <div className="d-flex align-items-center">
        <Button variant="outline-secondary" size="sm" onClick={handlePrevDay}>
          &lt;
        </Button>
        <div style={{ position: "relative", width: "200px" }}>
          <div
            className="d-flex align-items-center px-3 py-2 rounded text-white fw-bold"
            style={{ backgroundColor: "#1e293b", cursor: "pointer" }}
          >
            <span className="me-2">📅</span>
            {format(currentDate, "dd-MM-yyyy")}
          </div>
          <Form.Control
            type="date"
            value={format(currentDate, "yyyy-MM-dd")}
            onChange={handleDateChange}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              opacity: 0,
              cursor: "pointer",
            }}
          />
        </div>
        {/* <ButtonGroup className="ms-2"> */}

        <Button variant="outline-secondary" size="sm" onClick={handleNextDay}>
          &gt;
        </Button>
        {/* </ButtonGroup> */}
      </div>

      {/* Filter Controls */}
      <div className="d-flex align-items-center gap-2 flex-wrap">
        {[
          { key: "all", label: "All", count: counts.all },
          { key: "vacant", label: "Vacant", count: counts.vacant },
          { key: "occupied", label: "Occupied", count: counts.occupied },
          { key: "reserved", label: "Reserved", count: counts.reserved },
          { key: "booked", label: "Booked", count: 0 }, // Placeholder as per image
          { key: "due_out", label: "Due Out", count: 1 }, // Placeholder as per image
          { key: "dirty", label: "Dirty", count: 9 }, // Placeholder as per image
        ].map((item) => (
          <div
            key={item.key}
            onClick={() => setFilter(item.key)}
            className={`d-flex align-items-center px-3 py-2 rounded cursor-pointer ${
              filter === item.key ? "ring-2 ring-blue-500" : ""
            }`}
            style={{
              backgroundColor: "#f3f4f6",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            <span className="fw-bold text-secondary me-2">{item.label}</span>
            <span
              className="badge rounded-pill d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#84cc16", // Lime green
                width: "24px",
                height: "24px",
                fontSize: "12px",
              }}
            >
              {item.count}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarControls;
